export default "__VITE_ASSET__DjFO60gU__"